// import { useParams } from "react-router-dom";
// import Tabs from "./Tabs";

// export default function Analytics() {
//   const { id } = useParams();

//   return (
//     <div className="w-full bg-gray-50 min-h-screen p-8">
//       {/* Campaign Navigation */}
//       <Tabs activeTab="Analytics" campaignId={id} />

//       {/* Card */}
//       <div className="bg-white p-8 rounded-2xl shadow-md">
//         {/* Status Row */}
//         <div className="flex items-center justify-between mb-6">
//           <div className="flex items-center space-x-4">
//             <span className="text-gray-600 font-medium">Status:</span>
//             <span className="px-3 py-1 bg-gray-200 rounded-full text-gray-800 text-sm font-semibold">
//               Draft
//             </span>
//             <div className="w-40 bg-gray-200 rounded-full h-2">
//               <div className="bg-green-500 h-2 rounded-full" style={{ width: "100%" }}></div>
//             </div>
//             <span className="text-sm font-semibold text-gray-700">100%</span>
//           </div>

//           <div className="flex space-x-3">
//             <button className="border px-4 py-2 rounded-lg text-sm font-medium">
//               Share
//             </button>
//             <select className="border px-3 py-2 rounded-lg text-sm font-medium">
//               <option>Last 4 weeks</option>
//               <option>Last 7 days</option>
//               <option>Last 30 days</option>
//             </select>
//           </div>
//         </div>

//         {/* Stats Row */}
//         <div className="grid grid-cols-5 gap-4 mb-6">
//           {[
//             { label: "Sequence started", value: "-" },
//             { label: "Open rate", value: "0%" },
//             { label: "Click rate", value: "0%" },
//             { label: "Opportunities", value: "0 | $0" },
//             { label: "Conversions", value: "0 | $0" },
//           ].map((stat, idx) => (
//             <div
//               key={idx}
//               className="border rounded-xl p-4 text-center bg-gray-50"
//             >
//               <h4 className="text-gray-500 text-sm font-medium mb-2">
//                 {stat.label}
//               </h4>
//               <p className="text-xl font-bold text-gray-800">{stat.value}</p>
//             </div>
//           ))}
//         </div>

//         {/* Empty State */}
//         <div className="border rounded-xl p-6 text-center text-gray-500 mb-6">
//           No data available for specified time
//         </div>

//         {/* Step Analytics / Activity Tabs */}
//         <div className="border rounded-xl">
//           <div className="flex border-b">

//             <button className="px-6 py-3 text-gray-600 hover:text-gray-800">
//               Activity
//             </button>
//           </div>
//           <div className="p-6 text-center text-gray-500">
//             👋 Step analytics will appear here once the campaign is published
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }


import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "../../lib/axios";
import Tabs from "./Tabs";
import {
  Mail, CheckCircle, Eye, MousePointer, AlertCircle, Target, RefreshCw, Download,
  Sparkles, Brain, ThumbsUp, AlertTriangle, Lightbulb, TrendingUp, TrendingDown,
  Gauge, Shield, Zap, Award, BarChart3
} from "lucide-react";

export default function Analytics() {
  const { id } = useParams();
  const [analytics, setAnalytics] = useState(null);
  const [detailedData, setDetailedData] = useState(null);
  const [timeline, setTimeline] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("overview");
  const [aiInsights, setAiInsights] = useState(null);
  const [aiLoading, setAiLoading] = useState(false);
  const [prediction, setPrediction] = useState(null);
  const [predLoading, setPredLoading] = useState(false);
  const [abAnalysis, setAbAnalysis] = useState(null);
  const [abLoading, setAbLoading] = useState(false);

  useEffect(() => {
    fetchAnalytics();
    fetchDetailedData();
    fetchTimeline();
  }, [id]);

  const fetchAnalytics = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`email-campaign/analytics/${id}`);
      setAnalytics(response.data);
    } catch (error) {
      console.error("Error fetching analytics:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchDetailedData = async () => {
    try {
      const response = await axios.get(`email-campaign/analytics/${id}/detailed?page=1&per_page=50`);
      setDetailedData(response.data);
    } catch (error) {
      console.error("Error fetching detailed data:", error);
    }
  };

  const fetchTimeline = async () => {
    try {
      const response = await axios.get(`email-campaign/analytics/${id}/timeline`);
      setTimeline(response.data);
    } catch (error) {
      console.error("Error fetching timeline:", error);
    }
  };

  const fetchAiInsights = async () => {
    setAiLoading(true);
    try {
      const res = await axios.get(`reports/ai-campaign-insights/${id}`);
      if (res.data.insights) {
        setAiInsights(res.data);
      }
    } catch (error) {
      console.error("Error fetching AI insights:", error);
    } finally {
      setAiLoading(false);
    }
  };

  const fetchPrediction = async () => {
    setPredLoading(true);
    try {
      const res = await axios.get(`reports/predict-campaign/${id}`);
      if (!res.data.error) {
        setPrediction(res.data);
      }
    } catch (error) {
      console.error("Error fetching prediction:", error);
    } finally {
      setPredLoading(false);
    }
  };

  const fetchAbAnalysis = async () => {
    setAbLoading(true);
    try {
      const res = await axios.get(`reports/ab-test-analysis/${id}`);
      if (!res.data.error) {
        setAbAnalysis(res.data);
      }
    } catch (error) {
      console.error("Error fetching A/B analysis:", error);
    } finally {
      setAbLoading(false);
    }
  };

  const getStatusColor = (rate) => {
    if (rate >= 70) return "bg-green-500";
    if (rate >= 40) return "bg-yellow-500";
    return "bg-red-500";
  };

  const getStatusText = () => {
    if (!analytics) return "Loading...";
    if (analytics.total_sent === 0) return "Draft";
    if (analytics.total_sent > 0 && analytics.total_delivered === analytics.total_sent) return "Completed";
    return "In Progress";
  };

  const getProgressPercentage = () => {
    if (!analytics || analytics.total_sent === 0) return 0;
    return Math.round((analytics.total_delivered / analytics.total_sent) * 100);
  };

  if (loading) {
    return (
      <div className="page animate-fade-in">
        <Tabs activeTab="Analytics" campaignId={id} />
        <div className="card">
          <div style={{ padding: '4rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div className="animate-spin rounded-full h-12 w-12" style={{ border: '3px solid var(--color-border)', borderTopColor: 'var(--color-primary)' }}></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page animate-fade-in">
      <Tabs activeTab="Analytics" campaignId={id} />

      <div className="page-header">
        <div className="header-info">
          <h2>Campaign Analytics</h2>
          <p>Track performance metrics and engagement data</p>
        </div>
        <div className="header-actions">
          <button onClick={() => window.print()} className="btn btn-ghost btn-sm">
            <Download size={16} />
            Export
          </button>
          <button onClick={fetchAnalytics} className="btn btn-ghost btn-sm">
            <RefreshCw size={16} />
            Refresh
          </button>
        </div>
      </div>

      <div className="card" style={{ marginBottom: '1.5rem' }}>
        <div style={{ padding: '1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '1px solid var(--color-border)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <span style={{ color: 'var(--color-text-secondary)', fontWeight: 500 }}>Status:</span>
            <span className={`status-badge ${
              getStatusText() === "Completed" ? "status-badge" :
              getStatusText() === "In Progress" ? "status-badge" : "status-badge"
            }`} style={{
              background: getStatusText() === "Completed" ? 'rgba(34, 197, 94, 0.1)' :
                          getStatusText() === "In Progress" ? 'rgba(59, 130, 246, 0.1)' : 'rgba(156, 163, 175, 0.1)',
              color: getStatusText() === "Completed" ? '#22c55e' :
                     getStatusText() === "In Progress" ? '#3b82f6' : '#9ca3af'
            }}>
              {getStatusText()}
            </span>
            <div style={{ width: '160px', height: '8px', background: 'var(--color-bg-tertiary)', borderRadius: '4px', overflow: 'hidden' }}>
              <div
                style={{
                  height: '100%',
                  borderRadius: '4px',
                  background: getProgressPercentage() >= 70 ? '#22c55e' : getProgressPercentage() >= 40 ? '#f59e0b' : '#ef4444',
                  width: `${getProgressPercentage()}%`,
                  transition: 'width 0.5s ease'
                }}
              ></div>
            </div>
            <span style={{ fontSize: '0.875rem', fontWeight: 600, color: 'var(--color-text-secondary)' }}>
              {getProgressPercentage()}%
            </span>
          </div>
        </div>

        <div style={{ padding: '1.5rem' }}>
          <div className="stats-grid" style={{ gridTemplateColumns: 'repeat(6, 1fr)', marginBottom: '1.5rem' }}>
            {[
              {
                label: "Total Sent",
                value: analytics?.total_sent || 0,
                icon: <Mail size={20} />,
                color: "#6366f1"
              },
              {
                label: "Delivered",
                value: analytics?.total_delivered || 0,
                subtext: `${analytics?.delivery_rate || 0}%`,
                icon: <CheckCircle size={20} />,
                color: "#22c55e"
              },
              {
                label: "Opened",
                value: analytics?.unique_opens || 0,
                subtext: `${analytics?.open_rate || 0}%`,
                icon: <Eye size={20} />,
                color: "#8b5cf6"
              },
              {
                label: "Clicked",
                value: analytics?.total_clicks || 0,
                subtext: `${analytics?.click_rate || 0}%`,
                icon: <MousePointer size={20} />,
                color: "#3b82f6"
              },
              {
                label: "Bounced",
                value: analytics?.total_bounced || 0,
                subtext: `${analytics?.bounce_rate || 0}%`,
                icon: <AlertCircle size={20} />,
                color: "#ef4444"
              },
              {
                label: "Engagement",
                value: `${analytics?.engagement_score || 0}%`,
                subtext: "Overall",
                icon: <Target size={20} />,
                color: "#f59e0b"
              },
            ].map((stat, idx) => (
              <div key={idx} className="stat-card" style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', marginBottom: '0.75rem' }}>
                  <div className="stat-icon" style={{ background: `${stat.color}15`, color: stat.color }}>
                    {stat.icon}
                  </div>
                  {stat.subtext && (
                    <span className="status-badge small" style={{ background: `${stat.color}15`, color: stat.color }}>
                      {stat.subtext}
                    </span>
                  )}
                </div>
                <span className="stat-label">{stat.label}</span>
                <span className="stat-value">{stat.value}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {analytics && (analytics.total_sent > 0 || analytics.total_opens > 0 || analytics.total_clicks > 0) && (
        <div className="stats-grid" style={{ gridTemplateColumns: 'repeat(3, 1fr)', marginBottom: '1.5rem' }}>
          <div className="card">
            <div style={{ padding: '1.5rem' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.75rem' }}>
                <div>
                  <p style={{ fontSize: '0.875rem', color: 'var(--color-text-muted)', marginBottom: '0.5rem' }}>Delivery Rate</p>
                  <p style={{ fontSize: '2rem', fontWeight: 700, color: '#22c55e' }}>{analytics.delivery_rate}%</p>
                </div>
                <div className="stat-icon" style={{ background: 'rgba(34, 197, 94, 0.1)', color: '#22c55e' }}>
                  <CheckCircle size={24} />
                </div>
              </div>
              <p style={{ fontSize: '0.8rem', color: 'var(--color-text-muted)' }}>
                {analytics.total_delivered} of {analytics.total_sent} delivered
              </p>
            </div>
          </div>

          <div className="card">
            <div style={{ padding: '1.5rem' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.75rem' }}>
                <div>
                  <p style={{ fontSize: '0.875rem', color: 'var(--color-text-muted)', marginBottom: '0.5rem' }}>Open Rate</p>
                  <p style={{ fontSize: '2rem', fontWeight: 700, color: '#8b5cf6' }}>{analytics.open_rate}%</p>
                </div>
                <div className="stat-icon" style={{ background: 'rgba(139, 92, 246, 0.1)', color: '#8b5cf6' }}>
                  <Eye size={24} />
                </div>
              </div>
              <p style={{ fontSize: '0.8rem', color: 'var(--color-text-muted)' }}>
                {analytics.unique_opens} of {analytics.total_delivered} opened
              </p>
            </div>
          </div>

          <div className="card">
            <div style={{ padding: '1.5rem' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.75rem' }}>
                <div>
                  <p style={{ fontSize: '0.875rem', color: 'var(--color-text-muted)', marginBottom: '0.5rem' }}>Click-to-Open</p>
                  <p style={{ fontSize: '2rem', fontWeight: 700, color: '#3b82f6' }}>{analytics.click_to_open_rate}%</p>
                </div>
                <div className="stat-icon" style={{ background: 'rgba(59, 130, 246, 0.1)', color: '#3b82f6' }}>
                  <MousePointer size={24} />
                </div>
              </div>
              <p style={{ fontSize: '0.8rem', color: 'var(--color-text-muted)' }}>
                {analytics.total_clicks} of {analytics.total_opens} clicked
              </p>
            </div>
          </div>
        </div>
      )}

      {timeline && (timeline.opens_timeline.length > 0 || timeline.clicks_timeline.length > 0) ? (
        <div className="card" style={{ marginBottom: '1.5rem' }}>
          <div className="card-header">
            <h3>Performance Timeline</h3>
          </div>
          <div style={{ padding: '1.5rem' }}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '2rem' }}>
              <div>
                <h4 style={{ fontSize: '0.875rem', fontWeight: 600, color: 'var(--color-text-secondary)', marginBottom: '1rem' }}>Opens Over Time</h4>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                  {timeline.opens_timeline.map((item, idx) => (
                    <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                      <span style={{ fontSize: '0.75rem', color: 'var(--color-text-muted)', minWidth: '80px' }}>{item.date}</span>
                      <div style={{ flex: 1, height: '24px', background: 'var(--color-bg-tertiary)', borderRadius: '12px', overflow: 'hidden', position: 'relative' }}>
                        <div
                          style={{
                            height: '100%',
                            background: 'linear-gradient(90deg, #8b5cf6, #a855f7)',
                            borderRadius: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                            paddingRight: '0.5rem',
                            width: `${Math.min((item.count / Math.max(...timeline.opens_timeline.map(t => t.count))) * 100, 100)}%`,
                            transition: 'width 0.5s ease'
                          }}
                        >
                          <span style={{ fontSize: '0.75rem', fontWeight: 600, color: 'white' }}>{item.count}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <h4 style={{ fontSize: '0.875rem', fontWeight: 600, color: 'var(--color-text-secondary)', marginBottom: '1rem' }}>Clicks Over Time</h4>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                  {timeline.clicks_timeline.map((item, idx) => (
                    <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                      <span style={{ fontSize: '0.75rem', color: 'var(--color-text-muted)', minWidth: '80px' }}>{item.date}</span>
                      <div style={{ flex: 1, height: '24px', background: 'var(--color-bg-tertiary)', borderRadius: '12px', overflow: 'hidden', position: 'relative' }}>
                        <div
                          style={{
                            height: '100%',
                            background: 'linear-gradient(90deg, #3b82f6, #60a5fa)',
                            borderRadius: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                            paddingRight: '0.5rem',
                            width: `${Math.min((item.count / Math.max(...timeline.clicks_timeline.map(t => t.count))) * 100, 100)}%`,
                            transition: 'width 0.5s ease'
                          }}
                        >
                          <span style={{ fontSize: '0.75rem', fontWeight: 600, color: 'white' }}>{item.count}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : analytics && (analytics.total_sent > 0 || analytics.total_opens > 0 || analytics.total_clicks > 0) ? (
        <div className="card" style={{ marginBottom: '1.5rem' }}>
          <div style={{ padding: '3rem', textAlign: 'center', color: 'var(--color-text-muted)' }}>
            <Target size={48} style={{ margin: '0 auto 1rem', opacity: 0.5 }} />
            <p>Timeline data will appear as emails are opened and clicked</p>
          </div>
        </div>
      ) : (
        <div className="card" style={{ marginBottom: '1.5rem' }}>
          <div style={{ padding: '3rem', textAlign: 'center', color: 'var(--color-text-muted)' }}>
            <Mail size={48} style={{ margin: '0 auto 1rem', opacity: 0.5 }} />
            <p>No data available - Start sending emails to see analytics</p>
          </div>
        </div>
      )}

      <div className="card">
        <div className="filter-tabs" style={{ margin: '1rem', marginBottom: 0 }}>
          <button
            onClick={() => setActiveTab("overview")}
            className={`filter-tab ${activeTab === "overview" ? "active" : ""}`}
          >
            <Target size={16} />
            Overview
          </button>
          <button
            onClick={() => setActiveTab("recipients")}
            className={`filter-tab ${activeTab === "recipients" ? "active" : ""}`}
          >
            <Mail size={16} />
            Recipients
            <span className="count">{detailedData?.total || 0}</span>
          </button>
          <button
            onClick={() => { setActiveTab("ai-insights"); if (!aiInsights && !aiLoading) fetchAiInsights(); }}
            className={`filter-tab ${activeTab === "ai-insights" ? "active" : ""}`}
          >
            <Sparkles size={16} />
            AI Insights
          </button>
          <button
            onClick={() => { setActiveTab("predictions"); if (!prediction && !predLoading) fetchPrediction(); }}
            className={`filter-tab ${activeTab === "predictions" ? "active" : ""}`}
          >
            <Gauge size={16} />
            Predictions
          </button>
          <button
            onClick={() => { setActiveTab("ab-test"); if (!abAnalysis && !abLoading) fetchAbAnalysis(); }}
            className={`filter-tab ${activeTab === "ab-test" ? "active" : ""}`}
          >
            <BarChart3 size={16} />
            A/B Analysis
          </button>
        </div>

        <div style={{ padding: '1.5rem' }}>
          {activeTab === "overview" && (
            <div>
              {analytics && (analytics.total_sent > 0 || analytics.total_opens > 0 || analytics.total_clicks > 0) ? (
                <>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '1rem', marginBottom: '1.5rem' }}>
                    <div className="card" style={{ background: 'rgba(59, 130, 246, 0.05)' }}>
                      <div style={{ padding: '1.25rem' }}>
                        <h4 style={{ fontSize: '0.875rem', fontWeight: 600, color: '#3b82f6', marginBottom: '0.5rem' }}>Best Performing Metric</h4>
                        <p style={{ fontSize: '1.5rem', fontWeight: 700, color: '#3b82f6' }}>
                          {analytics.open_rate >= analytics.click_rate ? `${analytics.open_rate}% Open Rate` : `${analytics.click_rate}% Click Rate`}
                        </p>
                      </div>
                    </div>
                    <div className="card" style={{ background: 'rgba(34, 197, 94, 0.05)' }}>
                      <div style={{ padding: '1.25rem' }}>
                        <h4 style={{ fontSize: '0.875rem', fontWeight: 600, color: '#22c55e', marginBottom: '0.5rem' }}>Campaign Health</h4>
                        <p style={{ fontSize: '1.5rem', fontWeight: 700, color: '#22c55e' }}>
                          {analytics.bounce_rate < 5 ? "Excellent" : analytics.bounce_rate < 10 ? "Good" : "Needs Attention"}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="card" style={{ background: 'var(--color-bg-primary)' }}>
                    <div style={{ padding: '1.25rem' }}>
                      <p style={{ fontSize: '0.875rem', fontWeight: 600, marginBottom: '0.75rem', color: 'var(--color-text-primary)' }}>Campaign Insights</p>
                      <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                        <li style={{ fontSize: '0.875rem', color: 'var(--color-text-secondary)' }}>Campaign: {analytics.campaign_name}</li>
                        <li style={{ fontSize: '0.875rem', color: 'var(--color-text-secondary)' }}>Total Recipients: {analytics.total_sent}</li>
                        <li style={{ fontSize: '0.875rem', color: 'var(--color-text-secondary)' }}>Delivery Success: {analytics.delivery_rate}%</li>
                        <li style={{ fontSize: '0.875rem', color: 'var(--color-text-secondary)' }}>Engagement Score: {analytics.engagement_score}%</li>
                      </ul>
                    </div>
                  </div>
                </>
              ) : (
                <div style={{ padding: '3rem', textAlign: 'center', color: 'var(--color-text-muted)' }}>
                  <Target size={64} style={{ margin: '0 auto 1rem', opacity: 0.5 }} />
                  <p style={{ fontSize: '1.125rem', fontWeight: 500, marginBottom: '0.5rem' }}>Campaign analytics will appear here once emails are sent</p>
                  <p style={{ fontSize: '0.875rem' }}>Start your campaign to see detailed performance metrics</p>
                </div>
              )}
            </div>
          )}

          {activeTab === "ai-insights" && (
            <div>
              {aiLoading && (
                <div style={{ padding: '3rem', textAlign: 'center' }}>
                  <div style={{
                    width: 48, height: 48, border: '3px solid var(--color-border)',
                    borderTopColor: '#8b5cf6', borderRadius: '50%',
                    animation: 'spin 1s linear infinite', margin: '0 auto 1rem'
                  }} />
                  <p style={{ fontWeight: 600, color: 'var(--color-text-primary)' }}>Analyzing campaign with AI...</p>
                  <p style={{ fontSize: '0.8rem', color: 'var(--color-text-muted)' }}>This may take a few seconds</p>
                </div>
              )}

              {!aiLoading && !aiInsights?.insights && (
                <div style={{ padding: '3rem', textAlign: 'center' }}>
                  <Brain size={48} style={{ margin: '0 auto 1rem', opacity: 0.4, color: '#8b5cf6' }} />
                  <p style={{ fontSize: '1rem', fontWeight: 500, color: 'var(--color-text-muted)', marginBottom: '1rem' }}>
                    {analytics?.total_sent > 0
                      ? 'Click below to generate AI-powered insights for this campaign'
                      : 'Start sending emails to unlock AI insights'}
                  </p>
                  {analytics?.total_sent > 0 && (
                    <button className="btn btn-primary" onClick={fetchAiInsights} style={{
                      background: 'linear-gradient(135deg, #8b5cf6, #6366f1)',
                      border: 'none', padding: '0.625rem 1.5rem',
                      display: 'inline-flex', alignItems: 'center', gap: '0.5rem'
                    }}>
                      <Sparkles size={16} /> Generate Insights
                    </button>
                  )}
                </div>
              )}

              {!aiLoading && aiInsights?.insights && (() => {
                const ins = aiInsights.insights;
                const gradeColors = {
                  A: '#22c55e', B: '#3b82f6', C: '#f59e0b', D: '#f97316', F: '#ef4444'
                };
                return (
                  <>
                    {/* Grade + Summary */}
                    <div style={{ display: 'flex', gap: '1.25rem', marginBottom: '1.25rem' }}>
                      <div style={{
                        width: 100, minHeight: 100, borderRadius: '12px',
                        background: `${gradeColors[ins.performance_grade] || '#6366f1'}10`,
                        border: `2px solid ${gradeColors[ins.performance_grade] || '#6366f1'}30`,
                        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                        flexShrink: 0
                      }}>
                        <span style={{
                          fontSize: '2.5rem', fontWeight: 900,
                          color: gradeColors[ins.performance_grade] || '#6366f1'
                        }}>
                          {ins.performance_grade}
                        </span>
                        <span style={{ fontSize: '0.65rem', color: 'var(--color-text-muted)', fontWeight: 600 }}>GRADE</span>
                      </div>
                      <div style={{ flex: 1 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                          <Sparkles size={16} style={{ color: '#8b5cf6' }} />
                          <span style={{ fontWeight: 700, fontSize: '0.9rem', color: 'var(--color-text-primary)' }}>AI Analysis</span>
                          <button className="btn btn-ghost btn-sm" onClick={fetchAiInsights} style={{ marginLeft: 'auto', fontSize: '0.75rem' }}>
                            <RefreshCw size={13} /> Regenerate
                          </button>
                        </div>
                        <p style={{ fontSize: '0.875rem', lineHeight: 1.6, color: 'var(--color-text-secondary)', marginBottom: '0.5rem' }}>
                          {ins.summary}
                        </p>
                        <p style={{ fontSize: '0.775rem', color: 'var(--color-text-muted)', fontStyle: 'italic' }}>
                          {ins.grade_reason}
                        </p>
                      </div>
                    </div>

                    {/* Strengths + Weaknesses */}
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1.25rem' }}>
                      <div style={{ padding: '1rem', borderRadius: '10px', background: 'rgba(34, 197, 94, 0.04)', border: '1px solid rgba(34, 197, 94, 0.12)' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.375rem', marginBottom: '0.75rem' }}>
                          <ThumbsUp size={15} style={{ color: '#22c55e' }} />
                          <span style={{ fontWeight: 700, fontSize: '0.8rem', color: '#22c55e' }}>Strengths</span>
                        </div>
                        {ins.strengths?.map((s, i) => (
                          <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '0.5rem', marginBottom: '0.5rem' }}>
                            <CheckCircle size={14} style={{ color: '#22c55e', marginTop: 2, flexShrink: 0 }} />
                            <span style={{ fontSize: '0.8rem', color: 'var(--color-text-secondary)' }}>{s}</span>
                          </div>
                        ))}
                      </div>
                      <div style={{ padding: '1rem', borderRadius: '10px', background: 'rgba(239, 68, 68, 0.04)', border: '1px solid rgba(239, 68, 68, 0.12)' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.375rem', marginBottom: '0.75rem' }}>
                          <AlertTriangle size={15} style={{ color: '#ef4444' }} />
                          <span style={{ fontWeight: 700, fontSize: '0.8rem', color: '#ef4444' }}>Weaknesses</span>
                        </div>
                        {ins.weaknesses?.map((w, i) => (
                          <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '0.5rem', marginBottom: '0.5rem' }}>
                            <AlertCircle size={14} style={{ color: '#ef4444', marginTop: 2, flexShrink: 0 }} />
                            <span style={{ fontSize: '0.8rem', color: 'var(--color-text-secondary)' }}>{w}</span>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Recommendations */}
                    {ins.recommendations?.length > 0 && (
                      <div style={{ marginBottom: '1.25rem' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.375rem', marginBottom: '0.75rem' }}>
                          <Lightbulb size={16} style={{ color: '#f59e0b' }} />
                          <span style={{ fontWeight: 700, fontSize: '0.85rem', color: 'var(--color-text-primary)' }}>Recommendations</span>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                          {ins.recommendations.map((rec, i) => (
                            <div key={i} style={{
                              padding: '0.75rem 1rem', borderRadius: '8px',
                              background: 'var(--color-bg-primary)',
                              borderLeft: '3px solid #6366f1'
                            }}>
                              <p style={{ fontWeight: 600, fontSize: '0.825rem', color: 'var(--color-text-primary)', marginBottom: '0.2rem' }}>
                                {rec.action}
                              </p>
                              <p style={{ fontSize: '0.75rem', color: 'var(--color-text-muted)' }}>{rec.why}</p>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* Predicted Outcome + Best Step */}
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                      {ins.predicted_outcome && (
                        <div style={{
                          padding: '1rem', borderRadius: '10px',
                          background: 'rgba(99, 102, 241, 0.04)', border: '1px solid rgba(99, 102, 241, 0.12)'
                        }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '0.375rem', marginBottom: '0.5rem' }}>
                            <TrendingUp size={15} style={{ color: '#6366f1' }} />
                            <span style={{ fontWeight: 700, fontSize: '0.8rem', color: '#6366f1' }}>Predicted Outcome</span>
                          </div>
                          <p style={{ fontSize: '0.8rem', color: 'var(--color-text-secondary)', lineHeight: 1.5 }}>{ins.predicted_outcome}</p>
                        </div>
                      )}
                      {ins.best_performing_step && (
                        <div style={{
                          padding: '1rem', borderRadius: '10px',
                          background: 'rgba(34, 197, 94, 0.04)', border: '1px solid rgba(34, 197, 94, 0.12)'
                        }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '0.375rem', marginBottom: '0.5rem' }}>
                            <Target size={15} style={{ color: '#22c55e' }} />
                            <span style={{ fontWeight: 700, fontSize: '0.8rem', color: '#22c55e' }}>Best Performing Step</span>
                          </div>
                          <p style={{ fontWeight: 600, fontSize: '0.85rem', color: 'var(--color-text-primary)', marginBottom: '0.2rem' }}>{ins.best_performing_step.step}</p>
                          <p style={{ fontSize: '0.775rem', color: 'var(--color-text-muted)' }}>{ins.best_performing_step.reason}</p>
                        </div>
                      )}
                    </div>

                    {/* Footer */}
                    <div style={{ textAlign: 'center', padding: '0.75rem', fontSize: '0.7rem', color: 'var(--color-text-muted)', marginTop: '0.75rem' }}>
                      <Sparkles size={11} style={{ display: 'inline', verticalAlign: 'middle', marginRight: '0.25rem' }} />
                      AI-generated analysis · Engagement Score: {ins.engagement_score}/100
                    </div>
                  </>
                );
              })()}
            </div>
          )}

          {activeTab === "predictions" && (
            <div>
              {predLoading && (
                <div style={{ padding: '3rem', textAlign: 'center' }}>
                  <div style={{
                    width: 48, height: 48, border: '3px solid var(--color-border)',
                    borderTopColor: '#6366f1', borderRadius: '50%',
                    animation: 'spin 1s linear infinite', margin: '0 auto 1rem'
                  }} />
                  <p style={{ fontWeight: 600 }}>Predicting campaign outcomes...</p>
                  <p style={{ fontSize: '0.8rem', color: 'var(--color-text-muted)' }}>Analyzing early signals and historical data</p>
                </div>
              )}

              {!predLoading && !prediction && (
                <div style={{ padding: '3rem', textAlign: 'center' }}>
                  <Gauge size={48} style={{ margin: '0 auto 1rem', opacity: 0.4, color: '#6366f1' }} />
                  <p style={{ fontSize: '1rem', fontWeight: 500, color: 'var(--color-text-muted)', marginBottom: '1rem' }}>
                    {analytics?.total_sent > 0
                      ? 'Click below to predict campaign outcomes'
                      : 'Start sending emails to unlock predictions'}
                  </p>
                  {analytics?.total_sent > 0 && (
                    <button className="btn btn-primary" onClick={fetchPrediction} style={{
                      background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
                      border: 'none', padding: '0.625rem 1.5rem',
                      display: 'inline-flex', alignItems: 'center', gap: '0.5rem'
                    }}>
                      <Gauge size={16} /> Generate Prediction
                    </button>
                  )}
                </div>
              )}

              {!predLoading && prediction && !prediction.error && (() => {
                const p = prediction;
                const gradeColors = { A: '#22c55e', 'A+': '#22c55e', 'B+': '#3b82f6', B: '#3b82f6', 'C+': '#f59e0b', C: '#f59e0b', D: '#f97316', F: '#ef4444' };
                const gradeColor = gradeColors[p.predicted_grade] || '#6366f1';
                const confColors = { high: '#22c55e', medium: '#f59e0b', low: '#ef4444' };
                const trajIcons = { improving: <TrendingUp size={16} style={{ color: '#22c55e' }} />, stable: <Shield size={16} style={{ color: '#3b82f6' }} />, declining: <TrendingDown size={16} style={{ color: '#ef4444' }} /> };
                const trajColors = { improving: '#22c55e', stable: '#3b82f6', declining: '#ef4444' };

                return (
                  <>
                    {/* Grade + Confidence + Trajectory */}
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1rem', marginBottom: '1.25rem' }}>
                      <div style={{ padding: '1.25rem', borderRadius: 10, background: `${gradeColor}08`, border: `1px solid ${gradeColor}20`, textAlign: 'center' }}>
                        <span style={{ fontSize: '0.75rem', color: 'var(--color-text-muted)', fontWeight: 600 }}>PREDICTED GRADE</span>
                        <div style={{ fontSize: '2.5rem', fontWeight: 900, color: gradeColor, margin: '0.5rem 0' }}>{p.predicted_grade}</div>
                      </div>
                      <div style={{ padding: '1.25rem', borderRadius: 10, background: `${confColors[p.confidence] || '#6366f1'}08`, border: `1px solid ${confColors[p.confidence] || '#6366f1'}20`, textAlign: 'center' }}>
                        <span style={{ fontSize: '0.75rem', color: 'var(--color-text-muted)', fontWeight: 600 }}>CONFIDENCE</span>
                        <div style={{ fontSize: '1.5rem', fontWeight: 700, color: confColors[p.confidence] || '#6366f1', margin: '0.5rem 0', textTransform: 'uppercase' }}>{p.confidence}</div>
                        <p style={{ fontSize: '0.75rem', color: 'var(--color-text-muted)', margin: 0 }}>{p.confidence_reason}</p>
                      </div>
                      <div style={{ padding: '1.25rem', borderRadius: 10, background: `${trajColors[p.trajectory] || '#6366f1'}08`, border: `1px solid ${trajColors[p.trajectory] || '#6366f1'}20`, textAlign: 'center' }}>
                        <span style={{ fontSize: '0.75rem', color: 'var(--color-text-muted)', fontWeight: 600 }}>TRAJECTORY</span>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', margin: '0.5rem 0' }}>
                          {trajIcons[p.trajectory]}
                          <span style={{ fontSize: '1.5rem', fontWeight: 700, color: trajColors[p.trajectory] || '#6366f1', textTransform: 'capitalize' }}>{p.trajectory}</span>
                        </div>
                        <p style={{ fontSize: '0.75rem', color: 'var(--color-text-muted)', margin: 0 }}>{p.trajectory_detail}</p>
                      </div>
                    </div>

                    {/* Predicted Rates */}
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '1rem', marginBottom: '1.25rem' }}>
                      {[
                        { label: 'Open Rate', value: p.predicted_open_rate, color: '#8b5cf6', cmp: p.comparison_to_average?.open_rate },
                        { label: 'Click Rate', value: p.predicted_click_rate, color: '#3b82f6', cmp: p.comparison_to_average?.click_rate },
                        { label: 'Reply Rate', value: p.predicted_reply_rate, color: '#22c55e', cmp: p.comparison_to_average?.reply_rate },
                        { label: 'Bounce Rate', value: p.predicted_bounce_rate, color: '#ef4444', cmp: null },
                      ].map((m, i) => (
                        <div key={i} style={{ padding: '1rem', borderRadius: 10, background: 'var(--color-bg-primary)', border: '1px solid var(--color-border)', textAlign: 'center' }}>
                          <span style={{ fontSize: '0.75rem', color: 'var(--color-text-muted)', fontWeight: 600 }}>{m.label}</span>
                          <div style={{ fontSize: '1.75rem', fontWeight: 700, color: m.color, margin: '0.25rem 0' }}>{m.value}%</div>
                          {m.cmp && (
                            <span style={{
                              fontSize: '0.7rem', padding: '2px 8px', borderRadius: 4,
                              background: m.cmp.includes('above') ? '#dcfce7' : m.cmp.includes('below') ? '#fee2e2' : '#f3f4f6',
                              color: m.cmp.includes('above') ? '#16a34a' : m.cmp.includes('below') ? '#dc2626' : '#6b7280'
                            }}>
                              {m.cmp}
                            </span>
                          )}
                        </div>
                      ))}
                    </div>

                    {/* Summary */}
                    <div style={{ padding: '1rem', borderRadius: 10, background: 'rgba(99, 102, 241, 0.04)', border: '1px solid rgba(99, 102, 241, 0.12)', marginBottom: '1.25rem' }}>
                      <p style={{ fontSize: '0.875rem', lineHeight: 1.6, color: 'var(--color-text-secondary)', margin: 0 }}>{p.summary}</p>
                    </div>

                    {/* Risk Factors + Opportunities */}
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1.25rem' }}>
                      <div style={{ padding: '1rem', borderRadius: 10, background: 'rgba(239, 68, 68, 0.04)', border: '1px solid rgba(239, 68, 68, 0.12)' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.375rem', marginBottom: '0.75rem' }}>
                          <AlertTriangle size={15} style={{ color: '#ef4444' }} />
                          <span style={{ fontWeight: 700, fontSize: '0.8rem', color: '#ef4444' }}>Risk Factors</span>
                        </div>
                        {(p.risk_factors || []).map((r, i) => (
                          <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '0.5rem', marginBottom: '0.5rem' }}>
                            <AlertCircle size={14} style={{ color: '#ef4444', marginTop: 2, flexShrink: 0 }} />
                            <span style={{ fontSize: '0.8rem', color: 'var(--color-text-secondary)' }}>{r}</span>
                          </div>
                        ))}
                        {(!p.risk_factors || p.risk_factors.length === 0) && (
                          <p style={{ fontSize: '0.8rem', color: 'var(--color-text-muted)' }}>No significant risks detected</p>
                        )}
                      </div>
                      <div style={{ padding: '1rem', borderRadius: 10, background: 'rgba(34, 197, 94, 0.04)', border: '1px solid rgba(34, 197, 94, 0.12)' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.375rem', marginBottom: '0.75rem' }}>
                          <Zap size={15} style={{ color: '#22c55e' }} />
                          <span style={{ fontWeight: 700, fontSize: '0.8rem', color: '#22c55e' }}>Opportunities</span>
                        </div>
                        {(p.opportunities || []).map((o, i) => (
                          <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '0.5rem', marginBottom: '0.5rem' }}>
                            <CheckCircle size={14} style={{ color: '#22c55e', marginTop: 2, flexShrink: 0 }} />
                            <span style={{ fontSize: '0.8rem', color: 'var(--color-text-secondary)' }}>{o}</span>
                          </div>
                        ))}
                        {(!p.opportunities || p.opportunities.length === 0) && (
                          <p style={{ fontSize: '0.8rem', color: 'var(--color-text-muted)' }}>No additional opportunities identified</p>
                        )}
                      </div>
                    </div>

                    {/* Recommended Actions */}
                    {p.recommended_actions?.length > 0 && (
                      <div style={{ marginBottom: '0.75rem' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.375rem', marginBottom: '0.75rem' }}>
                          <Lightbulb size={16} style={{ color: '#f59e0b' }} />
                          <span style={{ fontWeight: 700, fontSize: '0.85rem' }}>Recommended Actions</span>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                          {p.recommended_actions.map((a, i) => (
                            <div key={i} style={{ padding: '0.75rem 1rem', borderRadius: 8, background: 'var(--color-bg-primary)', borderLeft: '3px solid #6366f1' }}>
                              <p style={{ fontSize: '0.825rem', color: 'var(--color-text-secondary)', margin: 0 }}>{a}</p>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* Regenerate */}
                    <div style={{ textAlign: 'center', paddingTop: '0.5rem' }}>
                      <button className="btn btn-ghost btn-sm" onClick={fetchPrediction} style={{ fontSize: '0.75rem' }}>
                        <RefreshCw size={13} /> Regenerate Prediction
                      </button>
                    </div>
                  </>
                );
              })()}
            </div>
          )}

          {activeTab === "ab-test" && (
            <div>
              {abLoading && (
                <div style={{ padding: '3rem', textAlign: 'center' }}>
                  <div style={{
                    width: 48, height: 48, border: '3px solid var(--color-border)',
                    borderTopColor: '#6366f1', borderRadius: '50%',
                    animation: 'spin 1s linear infinite', margin: '0 auto 1rem'
                  }} />
                  <p style={{ fontWeight: 600 }}>Analyzing A/B test variants...</p>
                  <p style={{ fontSize: '0.8rem', color: 'var(--color-text-muted)' }}>Comparing performance across variants</p>
                </div>
              )}

              {!abLoading && !abAnalysis && (
                <div style={{ padding: '3rem', textAlign: 'center' }}>
                  <BarChart3 size={48} style={{ margin: '0 auto 1rem', opacity: 0.4, color: '#6366f1' }} />
                  <p style={{ fontSize: '1rem', fontWeight: 500, color: 'var(--color-text-muted)', marginBottom: '1rem' }}>
                    {analytics?.total_sent > 0
                      ? 'Click below to analyze A/B test results'
                      : 'Start sending emails to unlock A/B analysis'}
                  </p>
                  {analytics?.total_sent > 0 && (
                    <button className="btn btn-primary" onClick={fetchAbAnalysis} style={{
                      background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
                      border: 'none', padding: '0.625rem 1.5rem',
                      display: 'inline-flex', alignItems: 'center', gap: '0.5rem'
                    }}>
                      <BarChart3 size={16} /> Analyze Variants
                    </button>
                  )}
                </div>
              )}

              {!abLoading && abAnalysis && !abAnalysis.error && (() => {
                const a = abAnalysis;
                const verdictColors = { strong: '#22c55e', good: '#3b82f6', average: '#f59e0b', weak: '#ef4444' };

                return (
                  <>
                    {/* Winner Card */}
                    {a.winner && (
                      <div style={{
                        padding: '1.25rem', borderRadius: 10, marginBottom: '1.25rem',
                        background: 'linear-gradient(135deg, rgba(34,197,94,0.05), rgba(34,197,94,0.1))',
                        border: '2px solid rgba(34,197,94,0.2)'
                      }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.75rem' }}>
                          <Award size={24} style={{ color: '#f59e0b' }} />
                          <div>
                            <span style={{ fontSize: '0.7rem', color: '#22c55e', fontWeight: 600, textTransform: 'uppercase' }}>Winner</span>
                            <h3 style={{ margin: 0, fontSize: '1.1rem', color: '#16a34a' }}>{a.winner.variant_label}</h3>
                          </div>
                          <span style={{
                            marginLeft: 'auto', fontSize: '0.7rem', padding: '3px 10px', borderRadius: 12,
                            background: a.winner.confidence === 'high' ? '#dcfce7' : a.winner.confidence === 'medium' ? '#fef3c7' : '#fee2e2',
                            color: a.winner.confidence === 'high' ? '#16a34a' : a.winner.confidence === 'medium' ? '#d97706' : '#dc2626',
                            fontWeight: 600
                          }}>
                            {a.winner.confidence} confidence
                          </span>
                        </div>
                        <p style={{ fontSize: '0.875rem', color: 'var(--color-text-secondary)', margin: '0 0 0.5rem', lineHeight: 1.5 }}>{a.winner.reason}</p>
                        <p style={{ fontSize: '0.775rem', color: 'var(--color-text-muted)', margin: 0, fontStyle: 'italic' }}>{a.winner.statistical_note}</p>
                      </div>
                    )}

                    {/* Variant Comparison Table */}
                    {a.variant_comparison?.length > 0 && (
                      <div style={{ marginBottom: '1.25rem' }}>
                        <h4 style={{ fontSize: '0.9rem', fontWeight: 600, marginBottom: '0.75rem' }}>Variant Comparison</h4>
                        <div className="table-container">
                          <table className="data-table">
                            <thead>
                              <tr>
                                <th>Variant</th>
                                <th>Subject</th>
                                <th>Sends</th>
                                <th>Open Rate</th>
                                <th>Click Rate</th>
                                <th>Bounce Rate</th>
                                <th>Score</th>
                                <th>Verdict</th>
                              </tr>
                            </thead>
                            <tbody>
                              {a.variant_comparison.map((v, i) => (
                                <tr key={i} style={{
                                  background: a.winner?.variant_label === v.variant_label ? 'rgba(34,197,94,0.04)' : 'transparent'
                                }}>
                                  <td style={{ fontWeight: 600 }}>
                                    {v.variant_label}
                                    {a.winner?.variant_label === v.variant_label && (
                                      <Award size={14} style={{ color: '#f59e0b', marginLeft: 4, verticalAlign: 'middle' }} />
                                    )}
                                  </td>
                                  <td style={{ fontSize: '0.8rem', maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{v.subject || '-'}</td>
                                  <td>{v.sends}</td>
                                  <td style={{ color: '#8b5cf6', fontWeight: 600 }}>{v.open_rate}%</td>
                                  <td style={{ color: '#3b82f6', fontWeight: 600 }}>{v.click_rate}%</td>
                                  <td style={{ color: '#ef4444', fontWeight: 600 }}>{v.bounce_rate}%</td>
                                  <td>
                                    <div style={{
                                      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                      width: 36, height: 36, borderRadius: '50%',
                                      background: v.score >= 70 ? '#dcfce7' : v.score >= 40 ? '#fef3c7' : '#fee2e2',
                                      color: v.score >= 70 ? '#16a34a' : v.score >= 40 ? '#d97706' : '#dc2626',
                                      fontWeight: 700, fontSize: '0.85rem'
                                    }}>
                                      {v.score}
                                    </div>
                                  </td>
                                  <td>
                                    <span style={{
                                      fontSize: '0.7rem', padding: '2px 8px', borderRadius: 4, fontWeight: 600, textTransform: 'uppercase',
                                      background: `${verdictColors[v.verdict] || '#6366f1'}15`,
                                      color: verdictColors[v.verdict] || '#6366f1'
                                    }}>
                                      {v.verdict}
                                    </span>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}

                    {/* Summary */}
                    <div style={{ padding: '1rem', borderRadius: 10, background: 'rgba(99, 102, 241, 0.04)', border: '1px solid rgba(99, 102, 241, 0.12)', marginBottom: '1.25rem' }}>
                      <p style={{ fontSize: '0.875rem', lineHeight: 1.6, color: 'var(--color-text-secondary)', margin: 0 }}>{a.summary}</p>
                    </div>

                    {/* Key Differences + Recommendations */}
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1.25rem' }}>
                      <div style={{ padding: '1rem', borderRadius: 10, background: 'rgba(139, 92, 246, 0.04)', border: '1px solid rgba(139, 92, 246, 0.12)' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.375rem', marginBottom: '0.75rem' }}>
                          <Brain size={15} style={{ color: '#8b5cf6' }} />
                          <span style={{ fontWeight: 700, fontSize: '0.8rem', color: '#8b5cf6' }}>Key Differences</span>
                        </div>
                        {(a.key_differences || []).map((d, i) => (
                          <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '0.5rem', marginBottom: '0.5rem' }}>
                            <span style={{ color: '#8b5cf6', fontWeight: 700, fontSize: '0.8rem' }}>{i + 1}.</span>
                            <span style={{ fontSize: '0.8rem', color: 'var(--color-text-secondary)' }}>{d}</span>
                          </div>
                        ))}
                      </div>
                      <div style={{ padding: '1rem', borderRadius: 10, background: 'rgba(245, 158, 11, 0.04)', border: '1px solid rgba(245, 158, 11, 0.12)' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.375rem', marginBottom: '0.75rem' }}>
                          <Lightbulb size={15} style={{ color: '#f59e0b' }} />
                          <span style={{ fontWeight: 700, fontSize: '0.8rem', color: '#f59e0b' }}>Recommendations</span>
                        </div>
                        {(a.recommendations || []).map((r, i) => (
                          <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '0.5rem', marginBottom: '0.5rem' }}>
                            <CheckCircle size={14} style={{ color: '#f59e0b', marginTop: 2, flexShrink: 0 }} />
                            <span style={{ fontSize: '0.8rem', color: 'var(--color-text-secondary)' }}>{r}</span>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Stop Test Recommendation */}
                    <div style={{
                      padding: '0.75rem 1rem', borderRadius: 8, marginBottom: '0.75rem',
                      background: a.should_stop_test ? 'rgba(34,197,94,0.05)' : 'rgba(59,130,246,0.05)',
                      border: `1px solid ${a.should_stop_test ? 'rgba(34,197,94,0.2)' : 'rgba(59,130,246,0.2)'}`,
                      display: 'flex', alignItems: 'center', gap: '0.75rem'
                    }}>
                      {a.should_stop_test
                        ? <CheckCircle size={18} style={{ color: '#22c55e', flexShrink: 0 }} />
                        : <Shield size={18} style={{ color: '#3b82f6', flexShrink: 0 }} />
                      }
                      <div>
                        <span style={{ fontWeight: 600, fontSize: '0.85rem', color: a.should_stop_test ? '#16a34a' : '#2563eb' }}>
                          {a.should_stop_test ? 'Ready to pick a winner' : 'Keep testing'}
                        </span>
                        <p style={{ fontSize: '0.8rem', color: 'var(--color-text-muted)', margin: '0.2rem 0 0' }}>{a.stop_reason}</p>
                      </div>
                    </div>

                    {/* Regenerate */}
                    <div style={{ textAlign: 'center', paddingTop: '0.5rem' }}>
                      <button className="btn btn-ghost btn-sm" onClick={fetchAbAnalysis} style={{ fontSize: '0.75rem' }}>
                        <RefreshCw size={13} /> Regenerate Analysis
                      </button>
                    </div>
                  </>
                );
              })()}
            </div>
          )}

          {activeTab === "recipients" && (
            <div>
              {detailedData && detailedData.recipients.length > 0 ? (
                <>
                  <div className="table-container">
                    <table className="data-table">
                      <thead>
                        <tr>
                          <th>Email</th>
                          <th>Status</th>
                          <th>Delivered</th>
                          <th>Opened</th>
                          <th>Clicked</th>
                        </tr>
                      </thead>
                      <tbody>
                        {detailedData.recipients.map((recipient, idx) => (
                          <tr key={idx}>
                            <td>{recipient.email}</td>
                            <td>
                              <span className="status-badge" style={{
                                background: recipient.status === "clicked" ? 'rgba(34, 197, 94, 0.1)' :
                                           recipient.status === "opened" ? 'rgba(59, 130, 246, 0.1)' :
                                           recipient.status === "delivered" ? 'rgba(156, 163, 175, 0.1)' :
                                           recipient.status === "bounced" ? 'rgba(239, 68, 68, 0.1)' :
                                           'rgba(245, 158, 11, 0.1)',
                                color: recipient.status === "clicked" ? '#22c55e' :
                                       recipient.status === "opened" ? '#3b82f6' :
                                       recipient.status === "delivered" ? '#9ca3af' :
                                       recipient.status === "bounced" ? '#ef4444' :
                                       '#f59e0b'
                              }}>
                                {recipient.status}
                              </span>
                            </td>
                            <td style={{ color: 'var(--color-text-secondary)' }}>{recipient.delivered_at || "-"}</td>
                            <td style={{ color: 'var(--color-text-secondary)' }}>{recipient.opened_at || "-"}</td>
                            <td style={{ color: 'var(--color-text-secondary)' }}>{recipient.clicked_at || "-"}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div style={{ marginTop: '1rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '0.875rem', color: 'var(--color-text-secondary)' }}>
                    <span>Showing {detailedData.recipients.length} of {detailedData.total} recipients</span>
                    <div style={{ display: 'flex', gap: '0.5rem' }}>
                      <button className="btn btn-ghost btn-sm">Previous</button>
                      <button className="btn btn-ghost btn-sm">Next</button>
                    </div>
                  </div>
                </>
              ) : (
                <div style={{ padding: '3rem', textAlign: 'center', color: 'var(--color-text-muted)' }}>
                  <Mail size={64} style={{ margin: '0 auto 1rem', opacity: 0.5 }} />
                  <p style={{ fontSize: '1.125rem', fontWeight: 500 }}>No recipient data available yet</p>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
